module.exports = __webpack_public_path__ + "static/media/chuck-norris.d1047c4e.png";